import React from 'react';
import '../CSS/MenuCategoryGrid.css';
import CategoryMenuItem from './CategoryMenuItem';

function MenuCategoryGrid({ items, onItemSelect, menuImages, categoryName }) {
  // Helper function to format category labels
  const formatCategoryLabel = (categoryId) => {
    const labelMap = {
      'ai-recommendations': 'Smart Choice',
      'appetizers': 'Appetizers',
      'entrees': 'Entrees',
      'drink': 'Drinks',
      'desserts': 'Desserts',
      'pizza': 'Pizza',
      'salads': 'Salads',
      'shareables': 'Shareables',
      'subs&burgers': 'Subs & Burgers',
      'smoothies': 'Smoothies',
      'healthy': 'Healthy Options',
      'tacos': 'Tacos',
      'burritos': 'Burritos',
      'enchiladas': 'Enchiladas',
      'quesadillas': 'Quesadillas',
      'fajitas': 'Fajitas',
      'margaritas': 'Margaritas',
      'bowls': 'Bowls'
    };
    return labelMap[categoryId] || categoryId.charAt(0).toUpperCase() + categoryId.slice(1);
  };

  if (!items || items.length === 0) {
    return <div className="menu-category-grid">No items found in this category</div>;
  }

  return (
    <div className="menu-category-grid-wrapper">
      <div className="category-header">
        <h2 className="category-title">{formatCategoryLabel(categoryName)}</h2>
      </div>
      <div className="menu-category-grid">
        {items.map((item) => (
          <CategoryMenuItem
            key={item.item_name}
            item={item}
            onClick={() => onItemSelect(item)}
            menuImages={menuImages}
          />
        ))}
      </div>
    </div>
  );
}

export default MenuCategoryGrid; 